import { Base } from '@studiometa/js-toolkit';

/**
 * Cart Items component
 */
export default class Items extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Items',
    refs: ['delete', 'quantity', 'datalayer'],
  };

  /**
   * @returns {number} quantity * unit price
   */
  get totalPrice() {
    return Number.parseFloat(this.$refs.datalayer.dataset.price * this.$refs.quantity.value);
  }

  /**
   * @returns {object} datalayer of items
   */
  get datalayer() {
    return {
      item_id: this.$refs.datalayer.dataset.id,
      item_name: this.$refs.datalayer.dataset.title,
      affiliation: this.$refs.datalayer.dataset.affiliation,
      discount:
        this.$refs.datalayer.dataset.discount <= 0
          ? undefined
          : Number.parseFloat(this.$refs.datalayer.dataset.discount),
      coupon: undefined,
      index: Number.parseFloat(this.$refs.datalayer.dataset.index),
      item_brand: this.$refs.datalayer.dataset.affiliation,
      item_category: this.$refs.datalayer.dataset.category,
      item_variant: this.$refs.datalayer.dataset.variant,
      location_id: undefined,
      price: this.$refs.datalayer.dataset.discountPrice
        ? Number.parseFloat(this.$refs.datalayer.dataset.discountPrice)
        : Number.parseFloat(this.$refs.datalayer.dataset.price),
      quantity: Number.parseFloat(this.$refs.quantity.value),
    };
  }
}
